import { CriterioTipoDado } from '@shared/criterio';
import { DataManagerColunaGrupo } from '../contracts/data-manager.model';
import { DataManagerProxy } from './data-manager-proxy';

export class DataManagerGrupo<T> {
  private _expandido = true;
  private _proxies: DataManagerProxy<T>[] = [];
  private _subGrupos: DataManagerGrupo<T>[] = [];
  private totaisGrupo = new Map<string, number>();

  constructor(
    private _key: number | string,
    private _coluna: DataManagerColunaGrupo,
    private _nivel: number,
    private _pai?: DataManagerGrupo<T>
  ) {
    _pai?._subGrupos.push(this);
  }

  get coluna() {
    return this._coluna;
  }

  get descricao() {
    const key = this.key;
    const coluna = this._coluna;
    const descricao =
      coluna.tipoColuna === 'simples' && coluna.lookup
        ? coluna.lookup(key)
        : key;

    if (
      (coluna.tipoColuna === 'criterio' || coluna.tipoColuna === 'simples') &&
      coluna.dadosAdicionais.length > 0
    ) {
      return coluna.dadosAdicionais?.reduce((prev, curr) => {
        if (curr.sel) {
          prev += ` - ${curr.lookup(key)}`;
        }
        return prev;
      }, descricao);
    }

    if (coluna.tipoDado === CriterioTipoDado.data) {
      const descString = descricao as string;
      return `${descString.substring(4, 6)}-${descString.substring(0, 4)}`;
    }

    return descricao;
  }

  get key() {
    return this._key;
  }

  get expandido() {
    return this._expandido;
  }

  get isGrupo() {
    return true;
  }

  get nivel() {
    return this._nivel;
  }

  get pai() {
    return this._pai;
  }

  get proxies() {
    return this._proxies;
  }

  get proxiesDeep() {
    return this._subGrupos.reduce(
      (prev, curr) => {
        prev.push(...curr.proxiesDeep);
        return prev;
      },
      [...this._proxies]
    );
  }

  get subGrupos() {
    return this._subGrupos;
  }

  get totalItens() {
    return this._subGrupos.reduce((prev, curr) => {
      prev += curr.totalItens;
      return prev;
    }, this._proxies.length);
  }

  get ultimoNivel() {
    return this._subGrupos.length === 0;
  }

  get visivel(): boolean {
    if (!this._pai) {
      return true;
    }
    if (!this._pai._expandido) {
      return false;
    }
    return this._pai.visivel;
  }

  set expandido(expandido: boolean) {
    this._expandido = expandido;
  }

  adicionarProxy(proxy: DataManagerProxy<T>) {
    this._proxies.push(proxy);
    let pai = this._pai;
    while (pai) {
      pai = pai._pai;
    }
  }

  clearProxies() {
    this._proxies = [];
  }

  excluirSubrupo(subGrupo: DataManagerGrupo<T>) {
    const index = this._subGrupos.findIndex((sg) => sg === subGrupo);
    if (index !== -1) {
      this._subGrupos.splice(index, 1);
    }
  }

  getTotal(colunaTotal: DataManagerColunaGrupo) {
    const totalKey = colunaTotal.id;
    return this.totaisGrupo.get(totalKey);
  }

  totalizarColuna(colunaTotal: DataManagerColunaGrupo, valor: number) {
    const totalKey = colunaTotal.id;
    const total = this.totaisGrupo.get(totalKey) || 0;
    this.totaisGrupo.set(totalKey, total + valor);

    if (this._pai) {
      this._pai.totalizarColuna(colunaTotal, valor);
    }
  }

  totalReset(colunaTotal: DataManagerColunaGrupo) {
    this.totaisGrupo.set(colunaTotal.id, 0);
  }
}
